import XIcon from "@/assets/icons/close.svg?react";
import { TranslationData } from "@/common/lib/types";
import Button from "@/components/ui/button/Button";
import Divider from "@/components/ui/divider/Divider";
import Modal from "@/components/ui/modal_new/Modal";
import TextField from "@/components/ui/textField/TextField";
import { useEffect, useState } from "react";

interface IProps {
  name: string;
  isOpen: boolean;
  onClose: () => void;
  translations: TranslationData;
  handleEdit: (title: string) => void;
}

const EditTitle = ({ isOpen, onClose, handleEdit, name, translations }: IProps) => {
  const [title, setTitle] = useState(name);
  const [showError, setShowError] = useState(false);

  const handleSubmit = () => {
    if (!title.trim()) {
      setShowError(true);
      return;
    } else setShowError(false);

    if (typeof handleEdit === "function") handleEdit(title);
    onClose();
  };

  const handleCancel = () => {
    setTitle(name);
    setShowError(false);
    onClose();
  };

  useEffect(() => {
    setTitle(name);
  }, [name]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      slots={{
        close: { visible: false },
        container: { className: "w-full max-w-[36.875rem] p-4" },
      }}
    >
      <div className="flex items-center justify-between px-8 py-5">
        <div>
          <h3 className="text-base">
            {translations?.lensConfigurator?.lens_config_prescription_edit_title}
          </h3>
          <p className="text-[0.75rem]">
            {translations?.lensConfigurator?.lens_config_prescription_edit_subtitle}
          </p>
        </div>
        <div className="cursor-pointer" onClick={onClose}>
          <XIcon className="h-3 w-3" />
        </div>
      </div>
      <Divider />
      <div className="mt-8 flex flex-col gap-9 px-8 pb-5">
        <TextField
          value={title}
          className="w-full"
          onChange={(e) => setTitle(e.target.value)}
          placeholder={translations?.lensConfigurator?.lens_config_prescription_edit_placeholder}
          slots={{
            label: {
              label: translations?.lensConfigurator?.lens_config_prescription_edit_title_label,
            },
            error: {
              variant: "transparent",
              error:
                showError && !title.trim()
                  ? translations?.lensConfigurator
                      ?.lens_config_prescription_name_input_empty_error_message
                  : "",
            },
          }}
        />
        <div className="flex flex-col gap-6">
          <Button className="w-full" onClick={handleSubmit}>
            {translations?.lensConfigurator?.lens_config_prescription_edit_save_label}
          </Button>
          <Button onClick={handleCancel} variant="link" className="mx-auto text-sm font-normal">
            {translations?.lensConfigurator?.lens_config_prescription_edit_cancel_label}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditTitle;
